import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { serviceURLService } from '../service/serviceURL';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../services/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SharingDataService } from '../service/sharing-data.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { environment } from './../../environments/environment';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-family-health-insurance',
  templateUrl: './family-health-insurance.component.html',
  styleUrls: ['./family-health-insurance.component.css'],
  providers: [CommonService]
})
export class FamilyHealthInsuranceComponent implements OnInit {
  modalRef: BsModalRef;
  loading: boolean;
  age: any;
  zeroNotAllow: boolean;
  invalidAgeError: boolean;
  quotesDetailsTable: boolean;
  selectedSumInsured: string = "5 Lakhs";
  familyAge: number;
  quoteDetails: any = {};
  careQuoteDetails: any = {};
  sendQuoteData: any = {};
  cityList: any = [];
  noResult = false;
  propspect: any = {};
  prospectId: any;
  familySize: any = 'Self Only';
  spouseSelected: any;
  childSize: any;
  quoteDetailId: any;
  quoteId: any;
  private onDestroy$: Subject<void> = new Subject<void>();
  childsList: any = [
    '1',
    '2',
    '3'
  ]
  familySizeLength: number;
  adultCount: number;

  insurer: any;
  sendCareQuoteData: any = {};
  partnerId: any;
  userDetails: any = {};
  roomRentSI: any;
  icuCharges: any;
  shouldBe18: boolean= false;
  shouldBe60: boolean= false;
  constructor(private serviceURLService: serviceURLService, private activatedRoute: ActivatedRoute, public commonService: CommonService, private modalService: BsModalService, public router: Router, public sharingDataService: SharingDataService) {
    this.userDetails.name = localStorage.getItem('name');
    this.userDetails.email = localStorage.getItem('email');
    this.userDetails.mobile = localStorage.getItem('mobileNumber');
    this.activatedRoute.queryParams.subscribe(params => {
      this.partnerId = params['partner'];
    });
  }

  ngOnInit() {
    this.getCities();
    this.getPrefilledData();
    if (!this.partnerId) {
      this.partnerId = environment.production ? '997' : '997';
    }
    this.createProspectt();
  }

  createProspectt() {

    let data = {
      mobile: this.userDetails.mobile,
      prospectId: "",
      rmId: "",
      product: 95,
      email: this.userDetails.email,
      name: this.userDetails.name,
      company: "",
      location: "",
      designation: "",
      comment: "",
      partnerId: this.partnerId,
      channel: "",
      leadSource: "",
      googleClickID: "",
      couponCode: ""
    }
   window.open(environment.pam2Url + '/individual-insurance/family-health-insurance/subComponents/CoverSelectionForm?redirectionFromApp=true&&mobile='+data.mobile+'&&product='+data.product+'&&email='+data.email+'&&name='+data.name+'&&partnerId='+data.partnerId)
   this.router.navigate(['/home'])
   return
    // if (!this.prospectId) {product this.router.navigate(['/home'])
    //   this.serviceURLService.saveFHIProspect(data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
    //     this.prospectId = successData.data.prospectId;
    //     localStorage.setItem("prospectIdFHI", this.prospectId);
    //     window.open(environment.pam2Url + '/individual-insurance/family-health-insurance/IndividualAge?prospect='
    //     + this.prospectId);
    //     this.router.navigate(['/home'])
    //     return
    //   }, errorData => {

    //   })
    // }
    // else{
    //   window.open(environment.pam2Url + '/individual-insurance/family-health-insurance/IndividualAge?prospect='
    //   + this.prospectId);
    //   this.router.navigate(['/home'])
    //   return
    // }
  }

  getPrefilledData() {
    this.propspect.name = localStorage.getItem('name');
    this.propspect.email = localStorage.getItem('email');
    this.propspect.mobile = localStorage.getItem('mobileNumber');
  }

  submitAge() {
    this.loading = true;
    var age = (<HTMLInputElement>document.getElementById("age")).value;
    var prospectId = localStorage.getItem('prospectIdFHI');
    var hostname = window.location.hostname;
    if (hostname == "staging.securenow.app" || hostname == "localhost") {
      window.location.replace("https://pamstaging.securenow.in/individual-insurance/health-insurance?isAmp=true&prospectId=" + prospectId + "&age=" + age);
    } else if (hostname == "securenow.app") {
      window.location.replace("https://securenow.in/individual-insurance/health-insurance?isAmp=true&prospectId=" + prospectId + "&age=" + age);
    }
  }

  checkZeroAsFirstInput($event) {
    var ageValue = (<HTMLInputElement>document.getElementById("age")).value;
    var proceedButton = <HTMLInputElement>document.getElementById("submitAge");
    if (ageValue.charAt(0) === '0') {
      proceedButton.disabled = true;
      this.zeroNotAllow = true;
    } else {
      this.zeroNotAllow = false;
      // this.invalidAgeError = false;
    }
  }

  //   submitAgeDetails1(){

//     if(this.familyAge < 18) {
//       this.shouldBe18 = true;
//       this.shouldBe60 = false;
//     } else if(this.familyAge > 60) {
//       this.shouldBe60 = true;
//       this.shouldBe18 = false;
//     } else {

//       window.open(environment.pam2Url + '/individual-insurance/family-health-insurance/Quotes='
//       + this.prospectId + '&age=' + this.age);

//       // this.router.navigate(['https://pamstaging2.securenow.in/individual-insurance/family-health-insurance/Quotes']);
//       // this.quotesDetailsTable = true;
//       this.loading = true;

//   }
// }

  submitAgeDetails() {   
    if(this.familyAge < 18) {
      this.shouldBe18 = true;
      this.shouldBe60 = false;
    } 
    else {

      window.open(environment.pam2Url + '/individual-insurance/family-health-insurance/Quotes?prospect='
      + this.prospectId + '&familyAge=' + this.familyAge);
      // this.quotesDetailsTable = true;
      this.loading = false;
      return;
    // sessionStorage.setItem('proposalInsuredFlag', '1');
    // if (this.familyAge > 25 && this.familyAge <= 30) {
    //   this.familySize = "Self and Spouse";
    //   this.familySizeLength = 2;
    //   this.adultCount = 2;
    //   this.spouseSelected = true;
    //   // (<HTMLInputElement>document.querySelector('input[value="1"]:checked'));
    //   // (<HTMLInputElement>document.getElementById("1"));
    //   // $('#5').prop('checked', 'checked');
    //   sessionStorage.setItem('proposalInsuredFlag', '2')
    // } else if (this.familyAge > 30 && this.familyAge <= 35) {
    //   this.familySize = "Self,Spouse and 1 Child";
    //   this.familySizeLength = 3;
    //   this.adultCount = 2;
    //   this.childSize = "1";
    //   this.spouseSelected = true;
    //   setTimeout(() => {
    //     (<HTMLInputElement>document.getElementById('1')).checked = true;
    //     (<HTMLInputElement>document.getElementById('2')).checked = false;
    //     (<HTMLInputElement>document.getElementById('3')).checked = false;
    //   }, 50);

    //   sessionStorage.setItem('proposalInsuredFlag', '3')

    // } else if (this.familyAge > 35 && this.familyAge <= 40) {
    //   this.familySize = "Self,Spouse and 2 Child";
    //   this.familySizeLength = 4;
    //   this.adultCount = 2;
    //   this.childSize = "2";
    //   this.spouseSelected = true;
    //   setTimeout(() => {
    //     (<HTMLInputElement>document.getElementById('1')).checked = false;
    //     (<HTMLInputElement>document.getElementById('2')).checked = true;
    //     (<HTMLInputElement>document.getElementById('3')).checked = false;
    //   }, 50);
    //   sessionStorage.setItem('proposalInsuredFlag', '4')
    // } else if (this.familyAge > 40 && this.familyAge <= 60) {
    //   this.familySize = "Self,Spouse and 3 Child";
    //   this.familySizeLength = 5;
    //   this.adultCount = 2;
    //   this.childSize = "3";
    //   this.spouseSelected = true;
    //   setTimeout(() => {
    //     (<HTMLInputElement>document.getElementById('1')).checked = false;
    //     (<HTMLInputElement>document.getElementById('2')).checked = false;
    //     (<HTMLInputElement>document.getElementById('3')).checked = true;
    //   }, 50);
    //   sessionStorage.setItem('proposalInsuredFlag', '5')
    // }
    let familyData = {
      'sumInsured': 'Rs. 5 Lakhs',
      'age': this.familyAge,
      'familyMembers': this.familySize,
    }
    this.serviceURLService.submitAgeDetail(familyData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.quotesDetailsTable = true;
      this.sendQuoteData = successData.data;
      //console.log(JSON.parse(successData.data));
      this.getQuoteDetails();
      this.getQuoteDetailsForCare();
    }, errorData => {
      this.loading = false;
      if (errorData.error.status === 401) {

      }
    });
  }
  }

  // getSpuseChecked(event) {
  //   this.spouseSelected = event.target.checked;
  //   this.getFamilySize('', '');
  //   // if(this.spouseSelected) {
  //   //   this.familySize = "Self and Spouse";
  //   // }
  //   // //this.getFamilySize(this.spouseSelected, '');
  //   // this.getQuoteDetails();
  // }

  // we have to improve this logic later
  getChildCheckedList(id) {
    setTimeout(() => {
      if ((<HTMLInputElement>document.getElementById(id)).checked == true) {
        (<HTMLInputElement>document.getElementById('1')).checked = false;
        (<HTMLInputElement>document.getElementById('2')).checked = false;
        (<HTMLInputElement>document.getElementById('3')).checked = false;
        (<HTMLInputElement>document.getElementById(id)).checked = true;
        return;
      } else {
        (<HTMLInputElement>document.getElementById('1')).checked = false;
        (<HTMLInputElement>document.getElementById('2')).checked = false;
        (<HTMLInputElement>document.getElementById('3')).checked = false;
        this.getFamilySize(null);
      }

    }, 50);
  }
  getFamilySize(childId) {
    // var checkValue = (<HTMLInputElement>document.getElementById(id)).checked;    

    if (!this.spouseSelected) {
      if (!this.childSize) {
        this.familySize = 'Self Only';
        this.getQuoteDetails();
        this.getQuoteDetailsForCare();
        return;
      }
      this.childSize = childId;
      this.familySize = 'Self and ' + this.childSize + ' child';
    } else {
      if (!this.childSize) {
        this.familySize = 'Self and Spouse';
        this.getQuoteDetails();
        this.getQuoteDetailsForCare();
        return;
      }
      this.childSize = childId;
      this.familySize = 'Self,Spouse and ' + this.childSize + ' child';

    }
    // console.log("familySize ",this.familySize);
    this.getQuoteDetails();
    this.getQuoteDetailsForCare();

    this.getChildCheckedList(childId);

  }
  // if(event.target.value !== 'spouse'){
  //   if (!child){
  //     this.familySize =  'Self Only';
  //   }
  //   //this.familySize = 'Self and' + child + 'child';
  // } else {
  //   if (!child){
  //     this.familySize = 'Self and Spouse';
  //   }
  //this.familySize = 'Self,Spouse and' + child + 'child';
  // if (event.target.value === 'spouse' && event.target.value === 'self') {
  //   this.sendQuoteData.XLEW_2_2_8 = 'Self and Spouse';
  // } else if(event.target.value === 'spouse' && event.target.value === '2 child') {
  //   this.sendQuoteData.XLEW_2_2_8 = 'Self,Spouse and 2 child';
  // } else if (event.target.value !== 'spouse' && event.target.value === '3 child') {
  //   this.sendQuoteData.XLEW_2_2_8 = 'Self and 3 child';
  // } else {
  //   this.sendQuoteData.XLEW_2_2_8 = 'Self Only';
  // }
  // this.getQuoteDetails();

  getCities() {
    this.loading = true;
    this.serviceURLService.getCities().pipe(takeUntil(this.onDestroy$)).subscribe(
      (success: any) => {
        this.loading = false;
        this.cityList = success.data.cityList;
      }, error => {
        this.loading = false;
      }
    )
  }


  selectCity(event: TypeaheadMatch): void {
    this.noResult = this.commonService.onSelectCity(event);
  }

  checkCityValue(event): void {
    this.noResult = this.commonService.checkCityValue(event, this.cityList);
  }

  openProspectModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false });
  }

  getQuoteDetails() {
    this.loading = true;
    this.sendQuoteData.XLEW_2_2_5 = this.selectedSumInsured;
    this.sendQuoteData.XLEW_2_2_8 = this.familySize;
    if (this.selectedSumInsured == "1 Lakh" || this.selectedSumInsured == "2 Lakhs" || this.selectedSumInsured == "3 Lakhs") {
        this.roomRentSI = "Up to 1% of Sum Insured";
        this.icuCharges = "Up to 2% of Sum Insured";
    } else {
      this.roomRentSI = "Single Private Room";
        this.icuCharges = "No Limits";
    }

    this.serviceURLService.getFamilyHeathQuote(this.sendQuoteData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      console.log(successData);
      this.quoteDetails = successData;
      this.loading = false;
    }, errorData => {
      this.loading = false;
    })
  }

  getQuoteDetailsForCare() {
    this.loading = true;
    var age = this.familyAge.toString();
    if(this.familySize == 'Self,Spouse and 2 Child' || this.familySize == 'Self,Spouse and 2 child') {
      this.familySize = 'Self, Spouse and 2 Child'
    } else if(this.familySize == 'Self,Spouse and 1 Child'  || this.familySize == 'Self,Spouse and 1 child') {
      this.familySize = 'Self, Spouse and 1 Child'
    }
    var sendCareQuoteDetails = {
      "XLEW_1_5_4": parseInt(age),
      "XLEW_2_2_3": this.familySize,
      "XLEW_2_3_3": this.selectedSumInsured
    }
    this.serviceURLService.getCareFamilyHeathQuote(sendCareQuoteDetails).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      console.log(successData);
      this.careQuoteDetails = successData;
      this.loading = false;
    }, errorData => {
      this.loading = false;
    })
  }

  sendDatainProposalForm() {
    let sendProposalData: any = {};
    sendProposalData = {
      'quoteDetails': this.quoteDetails,
      'childSize': this.childSize,
      'isspouse': this.spouseSelected,
      'quoteDetailId': this.quoteDetailId,
      'prospectId': this.prospectId,
      'quoteId': this.quoteId,
    }
    sessionStorage.setItem('fhiProposal', JSON.stringify(sendProposalData))
  }
  selectInsurer(insurer) {
    this.insurer = insurer;
    console.log(this.insurer);
  }

  createProspect(insurer) {
    this.loading = true;
    console.log(this.insurer + "287");
    if (insurer == 'unitedIndia') {
      this.propspect.coupon = "";
      this.propspect.email = localStorage.getItem("email");
      this.propspect.mobile = localStorage.getItem("mobileNumber");
      this.propspect.name = localStorage.getItem("name");
    }
    const prospectData = {
      coupon: this.propspect.coupon,
      email: this.propspect.email,
      location: this.propspect.location,
      mobile: this.propspect.mobile,
      name: this.propspect.name,
      prospectId: '',
      product: '95',
      leadSource:"Notify-App",
      channel:"Notify-App"
    }
    this.serviceURLService.createHealthProspect(prospectData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.prospectId = successData.data.prospectId;
      this.saveHealthDetails(this.insurer);
      this.loading = false;
    }, errorData => {
      this.loading = false;

    })
  }
  // createProspect(insurer) {
  //   this.loading = true;
  //   if (insurer == 'unitedIndia') {
  //     this.propspect.coupon = "";
  //     this.propspect.email = localStorage.getItem("email");
  //     this.propspect.mobile = localStorage.getItem("mobileNumber");
  //     this.propspect.name = localStorage.getItem("name");
  //   }
  //   const prospectData = {
  //     coupon: this.propspect.coupon,
  //     email: this.propspect.email,
  //     location: this.propspect.location,
  //     mobile: this.propspect.mobile,
  //     name: this.propspect.name,
  //     prospectId: '',
  //     product: '95'
  //   }
  //   this.serviceURLService.createHealthProspect(prospectData).subscribe((successData: any) => {
  //     this.prospectId = successData.data.prospectId;
  //     this.saveHealthDetails(insurer);
  //     this.loading = false;
  //   }, errorData => {
  //     this.loading = false;

  //   })
  // }


  saveHealthDetails(insurer) {
    this.loading = true;
    localStorage.setItem("familyAge", this.familyAge.toString());
    console.log(insurer);
    if (insurer == "royalSundaram") {
      var insurerLogo = 'RoyalSundaram Alliance Insurance Company Limited'
      var netPremiumInsurer = this.quoteDetails.XLEW_2_21_5;
    } else if (insurer == "careHealth") {
      var insurerLogo = 'Care Health Insurance Limited'
      var netPremiumInsurer = this.careQuoteDetails.XLEW_2_6_3;
      localStorage.setItem("carePremium", this.careQuoteDetails.XLEW_2_6_3);
    } else if (insurer == "unitedIndia") {
      var insurerLogo = 'United India Insurance Company Limited'
      var netPremiumInsurer = this.quoteDetails.XLEW_2_21_11;   
    }
    console.log(insurer)
    console.log(netPremiumInsurer)
    let saveData = {
      product: '95',
      prospectId: this.prospectId,
      age: this.familyAge,
      sumInsured: this.selectedSumInsured,
      familySize: this.familySize,
      totalChild: this.childSize ? this.childSize : 0,
      totalAdult: this.spouseSelected ? 1 : 0,
      netPremium: ["NA", "NA", netPremiumInsurer],
      insurerLogo: insurerLogo

      // netPremium: [this.quoteDetails.XLEW_2_21_5,"NA","NA"] // Use this for Royal Sundram
    }

    this.serviceURLService.HealthDetailsSave(saveData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      console.log(this.insurer + "330");
      if (this.insurer == "royalSundaram") {
        this.router.navigate(['health-insurance-proposal']);
        this.quoteDetailId = successData.data.quoteDetailId;
        this.quoteId = successData.data.quoteId;
        this.sendDatainProposalForm();
      } else if (this.insurer == "careHealth") {
        console.log(this.insurer);
        this.router.navigate(['family-health-care-proposal']);
        this.quoteDetailId = successData.data.quoteDetailId;
        this.quoteId = successData.data.quoteId;
        this.sendDatainProposalForm();
      }

      this.loading = false;
    }, errorData => {
      this.loading = false;

    })
  }

  showQuote() {
    this.quotesDetailsTable = true;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    
}
